module.exports = __webpack_public_path__ + "img/216.59451f7d.png";